import Button from 'components/Forms/Button/Button';
import { useSettings } from 'connectors/Settings/Settings';
import useTranslation from 'next-translate/useTranslation';
import dynamic from 'next/dynamic';
import { useSessionStore } from 'store/useSessionStore';
import twMerge from 'utils/twMerge';

const LegalGuaranteeNoticePopup = dynamic(
    () =>
        import('components/Blocks/LegalGuaranteeNotice/LegalGuaranteeNoticePopup').then(
            (component) => component.LegalGuaranteeNoticePopup,
        ),
    { ssr: false },
);

type LegalGuaranteeNoticeLinkProps = {
    className?: string;
};

export const LegalGuaranteeNoticeLink: FC<LegalGuaranteeNoticeLinkProps> = ({ className }) => {
    const { t } = useTranslation();
    const updatePortalContent = useSessionStore((state) => state.updatePortalContent);
    const settings = useSettings();

    if (!settings?.isHarmonisedNoticeAllowed) {
        return null;
    }

    return (
        <Button
            isLink
            aria-label={t('Harmonised notice (Legal guarantee)')}
            className={twMerge('cursor-pointer border-0 bg-transparent p-0 underline', className)}
            type="button"
            onClick={() => updatePortalContent(<LegalGuaranteeNoticePopup />)}
        >
            {t('Harmonised notice (Legal guarantee)')}
        </Button>
    );
};
